import { pick } from "lodash"
import { jsonHash } from "utils"

export const compareIntersectionEgalityOf2Objects = (
	object1: Record<string, unknown>,
	object2: Record<string, unknown>,
	intersectionProperties: Array<string>
) => {
	if (!intersectionProperties) return false
	const filteredObject1 = pick(object1, intersectionProperties)
	const filterObject2 = pick(object2, intersectionProperties)
	return jsonHash(filteredObject1) !== jsonHash(filterObject2)
}
